<template>
  <div class="home">
    <a-row :gutter="[16, 16]">
      <a-col :span="24">
        <a-card :bodyStyle="{ padding: 0 }">
          <a-table :columns="columns" :data-source="history" :expandRowByClick="true" :loading="loadingHistoryList"
                   :pagination="pagination"
                   rowKey="historyId" size="middle"
                   style="border-radius: 16px; overflow: hidden"
                   @change="handlePaginationChange">

            <div slot="dorm" slot-scope="record">
              {{ nodes.find(node => node.code === record.dorm).name }}
            </div>
            <div slot="description" slot-scope="record">
              {{ record.description }}
            </div>
            <div slot="historyChangeType" slot-scope="record">
              <span v-if="record.historyChangeType">
              {{ historyChangeType[record.historyChangeType] }}
              </span>
              <span v-else>-</span>
            </div>
            <div slot="created" slot-scope="record">
              {{ new Date(record.created) | moment('HH:mm - DD.MM.YYYY') }} r.
            </div>
            <div slot="expandedRowRender" slot-scope="record">
              <div class="table-details">
                <div v-if="record.account" style="margin-bottom: 0.5em">
                  <div v-if="record.description" style="margin-bottom: 0.5em">
                    <small style="font-weight: 700; color: #101010">Opis zdarzenia</small><br/>
                    {{ record.description }}
                  </div>
                  <small style="font-weight: 700; color: #101010">Użytkownik</small><br/>
                  {{
                    record.account.accountType !== 'COMMERCIAL' ? `${record.account.name} ${record.account.surname}`
                        : record.account.name
                  }}&nbsp;&bull;&nbsp;{{
                    (record.account.accountType !== 'COMMERCIAL' ? record.account.personId :
                        `${record.account.nip ? `NIP: ${record.account.nip}` : '-'}`).toUpperCase()
                  }}
                </div>
                <div v-if="record.account" style="margin-bottom: 0.5em">
                  <small style="font-weight: 700; color: #101010">Miejsce złożenia wniosku</small><br/>
                  {{ record.account.dorm.name }} {{ record.account.room }}
                </div>
                <div v-if="record.device" style="margin-bottom: 0.5em">
                  <small style="font-weight: 700; color: #101010">Urządzenie</small><br/>
                  {{ record.device.name }}&nbsp;&bull;&nbsp;{{ record.device.macAddress }}&nbsp;&bull;&nbsp;{{ record.device.activeLease.ip }}
                </div>
                <div v-if="record.device" style="margin-bottom: 0.5em">
                  <small style="font-weight: 700; color: #101010">Lokalizacja urządzenia</small><br/>
                  {{ record.device.activeLease.dorm.name }}
                </div>
                <div v-if="record.created" style="margin-bottom: 0.5em">
                  <small style="font-weight: 700; color: #101010">Data utworzenia zdarzenia</small><br/>
                  {{ new Date(record.created) | moment('HH:mm - DD.MM.YYYY') }} r.
                </div>
                <div style="margin-bottom: 0.5em; text-align: right;">
                  <a-button icon="user" type="primary" v-if="record.accountUuid"
                            @click="goTo({ name: 'User', params: { uuid: record.accountUuid } })">
                    Pokaż profil
                  </a-button>
                </div>
              </div>
            </div>
          </a-table>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>


<script>
import httpClient from "../utils/httpClient";

const historyChangeType = {
  "DEVICE_CREATED": 'Urządzenie utworzone',
  "DEVICE_ENABLED": 'Urządzenie włączone',
  "DEVICE_DISABLED": 'Urządzenie wyłączone',
  "DEVICE_DELETED": 'Urządzenie usunięte',
  "DEVICE_MOVED": 'Urządzenie przeniesione',
  "DEVICE_OWNER_CHANGED": 'Właściciel urządzenia zmieniony',
  "ACCOUNT_CREATED": 'Konto utworzone',
  "ACCOUNT_ACTIVATED": 'Konto aktywowane',
  "ACCOUNT_DISABLED": 'Konto zablokowane',
  "ACCOUNT_MOVED": 'Konto przeniesione',
  "ACCOUNT_BANNED": 'Konto zbanowane',
  "ACCOUNT_UNBANNED": 'Konto odbanowane',
  "ACCOUNT_DELETED": 'Konto usunięte',
  "LEASE_ENABLED": 'Lease włączony',
  "LEASE_DISABLED": 'Lease wyłączony',
  "ACCOUNT_DETAILS_UPDATED": 'Dane konta zaktualizowane',
}

const columns = [
  {title: 'Lokalizacja', key: 'dorm', scopedSlots: {customRender: 'dorm'}, width: 120},
  {title: 'Opis', dataIndex: 'description', key: 'description', ellipsis: true},
  {title: 'Typ zmiany', key: 'historyChangeType', scopedSlots: {customRender: 'historyChangeType'}, ellipsis: true},
  {title: 'Data utworzenia', key: 'created', scopedSlots: {customRender: 'created'}, width: 260},
  {
    title: '',
    key: 'operation',
    scopedSlots: {customRender: 'action'}
  },
];

export default {
  name: "Users",
  data() {
    return {
      columns,
      historyChangeType,
      loadingHistoryList: true,
      debounce: null,
      history: [],
      pagination: {
        current: 1,
        pageSize: 50,
        total: 1,
        defaultPageSize: 50,
      },
      nodes: [
        {
          id: 1,
          name: "D.S. Asystent",
          code: "ds-asystent",
        },
        {
          id: 2,
          name: "D.S. Bartek",
          code: "ds-bartek",
        },
        {
          id: 3,
          name: "D.S. Filon",
          code: "ds-filon",
        },
        {
          id: 4,
          name: "D.S. Laura",
          code: "ds-laura",
        },
        {
          id: 5,
          name: "D.S. Mimoza",
          code: "ds-mimoza",
        },
        {
          id: 6,
          name: "D.S. Proton",
          code: "ds-proton",
        }
      ],
    };
  },
  mounted() {
    this.getHistory()
    this.$emit("loadedView");
  },
  methods: {
    handleInput() {
      if (this.debounce) {
        clearTimeout(this.debounce);
      }
      this.debounce = setTimeout(this.getHistory, 300);
    },

    getHistory() {
      this.loadingHistoryList = true;
      httpClient
          .get(`/admin/history?size=${this.pagination.pageSize}&page=${this.pagination.current}`)
          .then((response) => {
            this.pagination = response.page;
            this.history = response.payload;
          }).finally(() => {
        this.loadingHistoryList = false;
      });
    },

    handlePaginationChange(pagination) {
      const {current, pageSize} = pagination;
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      this.getHistory()
    },

    goTo(obj) {
      if (this.$route.name !== obj.name) {
        this.$router.push(obj);
      }
    },
  },
};
</script>

<style scoped>
.table-details {
  background-color: rgba(200, 200, 200, 0.1);
  padding: 0.5em 1em;
  margin-right: 4px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 6px;
}

.legend-item {
  margin-left: 1.4em;

}
</style>
